export default __webpack_public_path__ + "static/media/3.b69c4652.jpg";